import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/bgcm-logo.png';

const Footer = () => {
  const footerStyles = {
    footer: {
      backgroundColor: '#06435f',
      color: '#fff',
      padding: '60px 20px 20px',
      fontFamily: 'Poppins, sans-serif',
    },
    footerContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    footerContent: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '40px',
      marginBottom: '40px',
    },
    footerSection: {
      marginBottom: '30px',
    },
    footerLogo: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
    },
    logoImage: {
      height: '60px',
      width: 'auto',
      marginRight: '15px',
    },
    companyName: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#fff',
      lineHeight: '1.4',
    },
    sectionTitle: {
      fontSize: '1.3rem',
      fontWeight: '600',
      marginBottom: '20px',
      color: '#fff',
      borderBottom: '2px solid var(--color-secondary)',
      paddingBottom: '10px',
    },
    footerText: {
      fontSize: '0.95rem',
      lineHeight: '1.8',
      color: 'rgba(255, 255, 255, 0.9)',
      marginBottom: '10px',
    },
    footerLink: {
      display: 'block',
      color: 'rgba(255, 255, 255, 0.9)',
      textDecoration: 'none',
      fontSize: '0.95rem',
      marginBottom: '12px',
      transition: 'color 0.3s ease, padding-left 0.3s ease',
    },
    footerLinkHover: {
      color: '#029fe2',
      paddingLeft: '5px',
    },
    socialLinks: {
      display: 'flex',
      gap: '15px',
      marginTop: '20px',
    },
    socialLink: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      textDecoration: 'none',
      fontSize: '1.2rem',
      transition: 'background-color 0.3s ease, transform 0.3s ease',
    },
    socialLinkHover: {
      backgroundColor: 'var(--color-secondary)',
      transform: 'translateY(-3px)',
    },
    contactInfo: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '15px',
      color: 'rgba(255, 255, 255, 0.9)',
    },
    contactIcon: {
      marginRight: '12px',
      fontSize: '1.2rem',
      color: 'var(--color-secondary)',
      marginTop: '3px',
      flexShrink: 0,
    },
    contactText: {
      fontSize: '0.95rem',
      lineHeight: '1.6',
      flex: 1,
    },
    copyright: {
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      paddingTop: '20px',
      textAlign: 'center',
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: '0.9rem',
    },
    proprietorInfo: {
      marginTop: '20px',
      paddingTop: '20px',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      width: '100%',
    },
  };

  return (
    <footer style={footerStyles.footer}>
      <div style={footerStyles.footerContainer}>
        <div style={footerStyles.footerContent}>
          {/* Company Info Section */}
          <div style={footerStyles.footerSection}>
            <div style={footerStyles.footerLogo}>
              <img src={logo} alt="BGCM Logo" style={footerStyles.logoImage} />
              <div style={footerStyles.companyName}>
                Bill Gates Offshore<br />Crew Manning Services
              </div>
            </div>
            <p style={footerStyles.footerText}>
              Leading provider of skilled maritime professionals for offshore operations worldwide. 
              Committed to excellence, safety, and reliability in crew manning services.
            </p>
            <div style={footerStyles.socialLinks}>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, footerStyles.socialLinkHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                aria-label="Facebook"
              >
                📘
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, footerStyles.socialLinkHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                aria-label="LinkedIn"
              >
                💼
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, footerStyles.socialLinkHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                aria-label="Twitter"
              >
                🐦
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, footerStyles.socialLinkHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                aria-label="Instagram"
              >
                📷
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, footerStyles.socialLinkHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                aria-label="YouTube"
              >
                ▶️
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div style={footerStyles.footerSection}>
            <h3 style={footerStyles.sectionTitle}>Quick Links</h3>
            <Link
              to="/"
              style={footerStyles.footerLink}
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, footerStyles.footerLinkHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.paddingLeft = '0';
              }}
            >
              Home
            </Link>
            <Link
              to="/about"
              style={footerStyles.footerLink}
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, footerStyles.footerLinkHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.paddingLeft = '0';
              }}
            >
              About Us
            </Link>
            <Link
              to="/services"
              style={footerStyles.footerLink}
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, footerStyles.footerLinkHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.paddingLeft = '0';
              }}
            >
              Services
            </Link>
            <Link
              to="/faq"
              style={footerStyles.footerLink}
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, footerStyles.footerLinkHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.paddingLeft = '0';
              }}
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              style={footerStyles.footerLink}
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, footerStyles.footerLinkHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                e.currentTarget.style.paddingLeft = '0';
              }}
            >
              Contact Us
            </Link>
          </div>

          {/* Contact Info Section */}
          <div style={footerStyles.footerSection}>
            <h3 style={footerStyles.sectionTitle}>Contact Information</h3>
            <div style={footerStyles.contactInfo}>
              <span style={footerStyles.contactIcon}>📍</span>
              <div style={footerStyles.contactText}>
                No.41/2, Middle street, Uvari.<br />
                Pin. 627651.<br />
                Tirunelveli District. Tamilnadu<br />
                South India.
              </div>
            </div>
            <div style={footerStyles.proprietorInfo}>
              <div style={{
                ...footerStyles.footerText,
                fontWeight: '600',
                marginBottom: '8px',
                color: 'rgba(255, 255, 255, 0.9)',
              }}>
                Proprietor
              </div>
              <div style={{
                ...footerStyles.footerText,
                marginBottom: 0,
                lineHeight: '1.8',
              }}>
                S. George Fernando<br />
                B.com, DCA, CCS
              </div>
            </div>
            <div style={{...footerStyles.contactInfo, marginTop: '20px'}}>
              <span style={footerStyles.contactIcon}>📧</span>
              <a
                href="mailto:santhiyagugeorge123@gmail.com"
                style={{
                  ...footerStyles.contactText,
                  color: 'rgba(255, 255, 255, 0.9)',
                  textDecoration: 'none',
                  display: 'block',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = 'var(--color-secondary)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                }}
              >
                santhiyagugeorge123@gmail.com
              </a>
            </div>
            <div style={footerStyles.contactInfo}>
              <span style={footerStyles.contactIcon}>📞</span>
              <a
                href="tel:+919789112382"
                style={{
                  ...footerStyles.contactText,
                  color: 'rgba(255, 255, 255, 0.9)',
                  textDecoration: 'none',
                  display: 'block',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = 'var(--color-secondary)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                }}
              >
                +91 9789112382
              </a>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div style={footerStyles.copyright}>
          <p>
            © {new Date().getFullYear()} Bill Gates Offshore Crew Manning Services. All rights reserved.
          </p>
          <p style={{marginTop: '10px', fontSize: '0.85rem'}}>
            Designed with excellence for maritime professionals worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
